
import { useEffect, useRef, useContext } from 'react';
import Spinner from '@ihs-widget/components/common/Spinner';
import { type IState, StateContext } from "../../../../state/stateContext"; // TODO: import from @ihs-widget/state/stateContext, not works why?
import { SCPlayersActiveFilterName } from "@ihs-widget/utils/enums";
import PlayersComparison from '@ihs-widget/components/StatsConsole/Widgets/PlayersWidget/parts/PlayersComparison';
import { addOppositeTeamWithZeroValues, switchDataStructureFromColumnsToRows } from './functions';
import { useLanguage } from '@ihs-widget/utils/hooks/useLanguage';
import { getEnumKeyByValue } from '@ihs-widget/utils/functions';
import { useTranslations } from '../../../../translation/TranslationContext';
import FiltersPlayers from './parts/FiltersPlayers';


interface IPlayersWidgetProps {
    eventId: string | null;
    statsData: any;
    playersTabData: any;
}

const PlayersWidget = ({ eventId, statsData, playersTabData }: IPlayersWidgetProps) => {

    const ctx = useContext(StateContext);
    const { stContext, setStContext } = ctx || {};
    const { playersTabActiveFilter, playersTabActiveFilterName } = stContext || {};
    const language = useLanguage();
    const t = useTranslations(language);
    const menuItemsPLContainerRef = useRef<HTMLDivElement>(null);

    const SCPlayersActiveFilter = {
        GOALS: t['InHouseStats.PlayersFilterGoals'] || '',
        ASSISTS: t['InHouseStats.PlayersFilterAssists'] || '',
        CARDS: t['InHouseStats.PlayersFilterCards'] || '',
        SHOTS: t['InHouseStats.PlayersFilterShots'] || ''
    } as const;

    type SCPlayersActiveFilterKey = keyof typeof SCPlayersActiveFilter;


    const getActiveFilterName = (filter: SCPlayersActiveFilterKey | null): SCPlayersActiveFilterName => {
        switch (filter) {
            case getEnumKeyByValue(SCPlayersActiveFilter, SCPlayersActiveFilter.GOALS):
                return SCPlayersActiveFilterName.GOALS;
            case getEnumKeyByValue(SCPlayersActiveFilter, SCPlayersActiveFilter.ASSISTS):
                return SCPlayersActiveFilterName.ASSISTS;
            case getEnumKeyByValue(SCPlayersActiveFilter, SCPlayersActiveFilter.CARDS):
                return SCPlayersActiveFilterName.CARDS;
            case getEnumKeyByValue(SCPlayersActiveFilter, SCPlayersActiveFilter.SHOTS):
                return SCPlayersActiveFilterName.SHOTS;
            default:
                return SCPlayersActiveFilterName.GOALS;
        }
    };

    const noData = {
        type: 'players-comparison',
        label: t['InHouseStats.PlayersNoData'] || '',
        rows: [
            {
                playerHome: " ",
                playerAway: " ",
                home: 0,
                away: 0
            }
        ]
    }

    const updateNoDataLabel = (newLabel: string) => {
        return {
            ...noData,
            label: newLabel
        };
    };


    useEffect(() => {
        if (playersTabActiveFilter) {
            setStContext((prev: IState) => ({
                ...prev,
                playersTabActiveFilterName: getActiveFilterName(playersTabActiveFilter)
            }));
        } else {
            setStContext((prev: IState) => ({
                ...prev,
                playersTabActiveFilterName: getActiveFilterName(getEnumKeyByValue(SCPlayersActiveFilter, SCPlayersActiveFilter.GOALS))
            }));
        }
    }, [playersTabActiveFilter, setStContext]);



    return (
        <div className='w-full' ref={menuItemsPLContainerRef}>
            <FiltersPlayers eventId={eventId} playersTabData={playersTabData} statsData={statsData} menuItemsPLContainerRef={menuItemsPLContainerRef} />
            {!playersTabData?.data?.match_statistics?.[playersTabActiveFilterName ?? SCPlayersActiveFilterName.GOALS]?.statistics
                ? <Spinner height='100px' />
                : null
            }
            {playersTabData?.data?.match_statistics?.[playersTabActiveFilterName ?? SCPlayersActiveFilterName.GOALS]?.statistics?.map((stat: any, index: number) => {
                if (stat.type === 'players-comparison' && stat.columns?.length === 0) {
                    const newNoDataStats = updateNoDataLabel(stat.label)
                    return <PlayersComparison key={index} data={newNoDataStats} noData={true} playersTabActiveFilter={playersTabActiveFilter} />
                } else if (stat.type === 'players-comparison' && stat.columns?.length === 1) {
                    const oppositeTeamColumns = addOppositeTeamWithZeroValues(stat.columns)
                    const newStats = {
                        type: stat.type,
                        label: stat.label || '',
                        columns: oppositeTeamColumns
                    }
                    const newStatsRows = newStats && switchDataStructureFromColumnsToRows(newStats)
                    return <PlayersComparison key={index} data={newStatsRows} noData={false} playersTabActiveFilter={playersTabActiveFilter} />
                } else if (stat.type === 'players-comparison' && stat.columns?.length > 0) {
                    const allColumnsEmpty = stat.columns.every((col: any) => !col.players || col.players.length === 0);
                    if (allColumnsEmpty) {
                        const newNoDataStats = updateNoDataLabel(stat.label)
                        return <PlayersComparison key={index} data={newNoDataStats} noData={true} playersTabActiveFilter={playersTabActiveFilter} />
                    }
                    const newStats = switchDataStructureFromColumnsToRows(stat)
                    return <PlayersComparison key={index} data={newStats} playersTabActiveFilter={playersTabActiveFilter} />
                }
            })}
        </div>
    )
}

export default PlayersWidget;
